import { z } from 'zod';
// ============================================================
// 리포트 발송 스케줄 — report_schedules / report_deliveries (FIKET-455, FIKET-437 공용)
// report_type·cadence·audience 는 pgEnum 이 아니라 varchar + 여기 Zod 로 검증한다.
// ============================================================
export const ReportTypeSchema = z.enum(['PROMOTION_PERFORMANCE']);
export const ReportAudienceSchema = z.enum(['INTERNAL', 'PARTNER']);
export const REPORT_AUDIENCE_LABELS = { INTERNAL: '내부용', PARTNER: '제휴사 공유용' };
export const ReportCadenceSchema = z.enum(['WEEKLY', 'MONTHLY']);
export const REPORT_CADENCE_LABELS = { WEEKLY: '매주', MONTHLY: '매월' };
export const REPORT_WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];
export const ReportPeriodKindSchema = z.enum(['WEEKLY', 'MONTHLY', 'CUSTOM']);
export const ReportDeliveryStatusSchema = z.enum(['SENT', 'PARTIAL', 'FAILED']);
/** 'YYYY-MM-DD' (KST 날짜) */
export const YmdSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD 형식이어야 합니다');
export const REPORT_RECIPIENTS_MAX = 20;
/** 수신자 — trim·소문자·중복 제거 후 1~20명. 입력은 배열(클라이언트가 태그 입력으로 만든다) */
export const ReportRecipientsSchema = z
    .array(z.string())
    .transform((arr) => Array.from(new Set(arr.map((s) => s.trim().toLowerCase()).filter(Boolean))))
    .pipe(z.array(z.string().email('이메일 형식이 아닙니다')).min(1, '수신자를 1명 이상 넣어 주세요').max(REPORT_RECIPIENTS_MAX, `수신자는 최대 ${REPORT_RECIPIENTS_MAX}명입니다`));
const scheduleBase = z.object({
    label: z.string().trim().max(60).optional(),
    audience: ReportAudienceSchema,
    cadence: ReportCadenceSchema,
    /** 0(일)~6(토). WEEKLY 필수 */
    sendWeekday: z.number().int().min(0).max(6).optional(),
    /** 1~31. MONTHLY 필수. 그 달에 없는 날이면 말일에 발송 */
    sendDay: z.number().int().min(1).max(31).optional(),
    recipients: ReportRecipientsSchema,
    isActive: z.boolean().optional(),
});
/** 주기와 요일/날짜 정합 — Create 와 서버의 PATCH 병합 검증이 함께 쓴다 */
export function refineReportCadence(v, ctx) {
    if (v.cadence === 'WEEKLY' && v.sendWeekday == null) {
        ctx.addIssue({ code: 'custom', path: ['sendWeekday'], message: '주간 발송은 요일을 골라 주세요' });
    }
    if (v.cadence === 'MONTHLY' && v.sendDay == null) {
        ctx.addIssue({ code: 'custom', path: ['sendDay'], message: '월간 발송은 날짜를 골라 주세요' });
    }
}
export const ReportScheduleCreateSchema = scheduleBase.superRefine(refineReportCadence);
/**
 * PATCH 용 — Create.partial() 로 만들지 않는다(zod4 에서 default 가 빈 PATCH 를 덮어쓰는 함정).
 * cadence 를 바꾸면 요일/날짜도 함께 보내야 한다(서버가 병합 후 refineReportCadence 재검증).
 */
export const ReportScheduleUpdateSchema = z.object({
    label: z.string().trim().max(60).nullable().optional(),
    audience: ReportAudienceSchema.optional(),
    cadence: ReportCadenceSchema.optional(),
    sendWeekday: z.number().int().min(0).max(6).nullable().optional(),
    sendDay: z.number().int().min(1).max(31).nullable().optional(),
    recipients: ReportRecipientsSchema.optional(),
    isActive: z.boolean().optional(),
});
/** 즉시 발송 / 다운로드 공용 기간 지정 */
export const ReportPeriodInputSchema = z
    .object({
    kind: ReportPeriodKindSchema,
    from: YmdSchema.optional(),
    to: YmdSchema.optional(),
})
    .superRefine((v, ctx) => {
    if (v.kind === 'CUSTOM') {
        if (!v.from || !v.to)
            ctx.addIssue({ code: 'custom', path: ['from'], message: '직접 지정은 시작일과 종료일이 필요합니다' });
        else if (v.from > v.to)
            ctx.addIssue({ code: 'custom', path: ['to'], message: '종료일이 시작일보다 빠릅니다' });
    }
});
export const ReportSendSchema = z.object({
    audience: ReportAudienceSchema,
    period: ReportPeriodInputSchema,
    recipients: ReportRecipientsSchema,
});
//# sourceMappingURL=report-schedule.js.map